// Bar imges
//cheers bar
import BarImg1 from '../Images/Resized/Bar/BAR-01.jpg'
import BarImg2 from '../Images/Resized/Bar/BAR-02.jpg'
import BarImg3 from '../Images/Resized/Bar/BAR-03.jpg'
import BarImg13 from '../Images/Resized/Bar/BAR-04.jpg'

//Gardan Bar
import BarImg4 from '../Images/Resized/Bar/OJS_4906.webp'
import BarImg5 from '../Images/Resized/Bar/OJS_4897.webp'
import BarImg6 from '../Images/Resized/Bar/OJS_4897.webp'

//third umpire
import BarImg7 from '../Images/Resized/Bar/Thirdumpire (1).png'
import BarImg8 from '../Images/Resized/Bar/Thirdumpire (2).png'
import BarImg9   from '../Images/Resized/Bar/Thirdumpire (2).png'

//JC Prime
import BarImg10 from '../Images/Resized/Bar/Jc prime Roof Top Bar.webp'
import BarImg11 from '../Images/Resized/Bar/IMG_8123-HDR-2.png'
import BarImg12 from '../Images/Resized/Bar/IMG_8110-HDR-2.png'


//Games
import GamesImg5 from '../Images/Resized/Games/Badminton Hall.avif';
import GamesImg6 from '../Images/Resized/Games/BILLIARDS-04.png';
import GamesImg3 from '../Images/Resized/Games/Grass Tennis Court.jpg';
import GamesImg4 from '../Images/Resized/Games/box-cricket-1.png';
import GamesImg1 from '../Images/Resized/Swimming Pool/HealthClub.jpeg';
import GamesImg2 from '../Images/Resized/Games/TENNIS CLAY COURT.jpg';
//Banquet

//Dinning Hall
import Dinning1 from '../Images/Resized/Dinning/Dinning Hall (2).jpg'
import Dinning2 from '../Images/Resized/Dinning/Dinning Hall (3).jpg'
import Dinning3 from '../Images/Resized/Dinning/Dinning Hall (6).jpg'
//Family Room
import Dinning4 from '../Images/Resized/Dinning/Family Room (5).jpg'
import Dinning5 from '../Images/Resized/Dinning/Family Room (3).jpg'
import Dinning6 from '../Images/Resized/Dinning/Family Room (2).jpg'

//Third Umpire
import Dinning7 from '../Images/Resized/Third Umpire/IMG_0271.png'
import Dinning8 from '../Images/Resized/Third Umpire/IMG_0283.png'
import Dinning9 from '../Images/Resized/Third Umpire/IMG_0285.png'

//JC Prime Rooftop
import Dinning10 from '../Images/Resized/Jc Prime/IMG_8123-HDR-2.jpg'
import Dinning11 from '../Images/Resized/Jc Prime/IMG_8128-HDR_edited.png'
import Dinning12 from '../Images/Resized/Jc Prime/IMG_8137-HDR-2.png'
//GYM
import GymImg1 from '../Images/Resized/GYM/GYM-01.jpg'
import GymImg2 from '../Images/Resized/GYM/GYM-02.jpg'

//Saloon
import GymImg3 from '../Images/Resized/saloon/001.jpeg'
import GymImg4 from '../Images/Resized/saloon/002.jpeg'
import GymImg15 from '../Images/Resized/saloon/009.jpeg'
import GymImg22 from '../Images/Resized/saloon/004.jpeg'
import GymImg21 from '../Images/Resized/saloon/006.jpeg'
//Heath club
import GymImg5 from '../Images/HealthClub.jpeg'
//pickel ball
import GymImg6 from '../Images/Resized/Games/picket-ball- (1).png'
import GymImg7 from '../Images/Resized/Games/picket-ball- (2).png'
import GymImg8 from '../Images/Resized/Games/picket-ball- (3).png'

//box cricket
import GymImg9 from '../Images/Resized/Games/box-cricket-3.png'
import GymImg10 from '../Images/Resized/Games/box-cricket-2.png'
import GymImg11 from '../Images/Resized/Games/box-cricket-1.png'
import box from '../Images/Resized/Games/Box Cricket.avif'

//Tennis
import GymImg12 from '../Images/Resized/Games/Grass Tennis Court.jpg'
import GymImg13 from '../Images/Resized/Games/Synthetic Tennis Court-01.jpg'
import GymImg14 from '../Images/Resized/Games/TENNIS CLAY COURT.jpg'

//Billiards
import GymImg16 from '../Images/Resized/Games/BILLIARDS-04.png'
import GymImg17 from '../Images/Resized/Games/Billiards Room.png'
import GymImg18 from '../Images/Resized/Games/BILLIARDS-01.png'

//badminton

import GymImg19 from '../Images/Resized/Games/BADMINTON HALL-01.jpg'
import GymImg20 from '../Images/Resized/Games/BADMINTON HALL-02.jpg'


//Swimming
import SwimmingImg1 from '../Images/Resized/Swimming Pool/IMG_0248.png'
import SwimmingImg2 from '../Images/Resized/Swimming Pool/IMG_0242.png'
import SwimmingImg3 from '../Images/Resized/Swimming Pool/IMG_0241.png'
import SwimmingImg4 from '../Images/Resized/Swimming Pool/IMG_9773.png'
import SwimmingImg5 from '../Images/Resized/Swimming Pool/IMG_9770.png'


//Card Game

import Card1 from "../Images/Resized/card game/Card game.avif"
import Card2 from "../Images/Resized/card game/Card Game-1.avif"



//Lawns

//ashok
import Lawn1 from "../Images/Resized/lawn/Ashok Marg Lawn (1).avif"
import Lawn2 from "../Images/Resized/lawn/Ashok Marg Lawn (2).avif"
import Lawn17 from "../Images/Resized/lawn/Ashok Marg Lawn (3).avif"
//children
import Lawn3 from "../Images/Resized/lawn/Children Lawn.png"
//maurya
import Lawn4 from "../Images/Resized/lawn/03.avif"
import Lawn16 from "../Images/Resized/lawn/04.avif"
import Lawn5 from "../Images/Resized/lawn/price-1.JPG";
import Lawn6 from "../Images/Resized/lawn/price-2.JPG";
import Lawn7 from "../Images/Resized/lawn/price-3.JPG";

//karaoke
import Lawn8 from "../Images/Resized/lawn/Karaoke Hall.png";
import Lawn11 from "../Images/Resized/lawn/Surai Hall-01.jpg";
import Lawn10 from "../Images/Resized/lawn/Surai Hall-02.jpg";
import Lawn9 from "../Images/Resized/lawn/Karaoke Room-02.jpg";

//Fountain Garden
import Lawn12 from "../Images/Resized/lawn/Lawn (1).avif";
import Lawn13 from "../Images/Resized/lawn/Lawn (2).avif";
import Lawn14 from "../Images/Resized/lawn/RoseGarden (1).jpg";
import Lawn15 from "../Images/Resized/lawn/RoseGarden (2).jpg";

//Member Night

import MNight from "../Images/Events/MemberNight/10960341@_MG_0965.png"
import MNight1 from "../Images/Events/MemberNight/12981792@_MG_0838.png"
import MNight2 from "../Images/Events/MemberNight/5937897@_MG_1136.png"
import MNight3 from "../Images/Events/MemberNight/6171175@_MG_1315.png"
import MNight4 from "../Images/Events/MemberNight/6780264@_MG_0860.png"
import MNight5 from "../Images/Events/MemberNight/7179616@_MG_1378.png"


//lohri
import lohri1 from "../Images/Resized/Lohri 2025/Lohari.jpg";
import lohri2 from "../Images/Resized/Lohri 2025/Lohari2.jpg";
import lohri3 from "../Images/Resized/Lohri 2025/Lohari3.jpg";
import lohri4 from "../Images/Resized/Lohri 2025/Lohari4.jpg";
import lohri5 from "../Images/Resized/Lohri 2025/Lohari5.jpg";

// Independence Day
import Independence from "../Images/Events/15Aug2023/aug-1.jpg";
import Independence2 from "../Images/Events/15Aug2023/aug-2.jpg";
import Independence3 from "../Images/Events/15Aug2023/aug-3.jpg";
import Independence4 from "../Images/Events/15Aug2023/aug-4.jpg";
import Independence5 from "../Images/Events/15Aug2023/aug-5.jpg";

//Republic
import Republic from "../Images/Events/26 Jan 2024/jan-1.jpg";
import Republic1 from "../Images/Events/26 Jan 2024/jan-2.jpg";
import Republic2 from "../Images/Events/26 Jan 2024/jan-3.jpg";
import Republic3 from "../Images/Events/26 Jan 2024/jan-4.jpg";
import Republic4 from "../Images/Events/26 Jan 2024/jan-5.jpg";


//Dandiya
import Dandiya5 from "../Images/Events/Dandiya2024/dandiya-1.jpg";
import Dandiya1 from "../Images/Events/Dandiya2024/dandiya-2.jpg";
import Dandiya2 from "../Images/Events/Dandiya2024/dandiya-3.jpg";
import Dandiya3 from "../Images/Events/Dandiya2024/dandiya-4.jpg";
import Dandiya4 from "../Images/Events/Dandiya2024/dandiya-5.jpg";


//Diwali
import diwali1 from "../Images/Events/Diwali2023/D-1.jpg";
import diwali2 from "../Images/Events/Diwali2023/D-2.jpg";
import diwali3 from "../Images/Events/Diwali2023/D-3.jpg";
import diwali4 from "../Images/Events/Diwali2023/D-4.jpg";
import diwali5 from "../Images/Events/Diwali2023/D-5.jpg";


//member night
import Night1 from "../Images/Events/FuisionNight2023/FN-1.jpg";
import Night2 from "../Images/Events/FuisionNight2023/FN-2.jpg";
import Night3 from "../Images/Events/FuisionNight2023/FN-3.jpg";
import Night4 from "../Images/Events/FuisionNight2023/FN-4.jpg";
import Night5 from "../Images/Events/FuisionNight2023/FN-5.jpg";

//new year
import New1 from "../Images/Events/NewYear2024/new-1.jpg";
import New2 from "../Images/Events/NewYear2024/new-2.jpg";
import New3 from "../Images/Events/NewYear2024/new-3.jpg";
import New4 from "../Images/Events/NewYear2024/new-4.jpg";
import New5 from "../Images/Events/NewYear2024/new-5.jpg";


import Room1 from "../Images/Resized/Jc Prime/Delux_Room.jpg";
import Room2 from "../Images/Resized/Jc Prime/Executive_Room.jpg";
import Room3 from "../Images/Resized/Jc Prime/WhatsApp Image 2025-06-11 at 2.35.10 PM.jpeg";
import Room4 from "../Images/Resized/Jc Prime/WhatsApp Image 2025-06-11 at 2.35.06 PM.jpeg";
import Room5 from "../Images/Resized/Jc Prime/Suite_Room.jpg";

import doc from "../Images/Resized/doctor room/IMG_9798.png"
import doc1 from "../Images/Resized/doctor room/IMG_9807.png"
import doc2 from "../Images/Resized/doctor room/IMG_9810.png"
import doc3 from "../Images/Resized/doctor room/IMG_9816.png"
import doc4 from "../Images/Resized/doctor room/IMG_9837.png"
import doc5 from "../Images/Resized/doctor room/IMG_9839.png"


import cHall from "../Images/Conference Hall/WhatsApp Image 2025-06-19 at 2.14.48 PM.jpeg"
import cHall1 from "../Images/Conference Hall/WhatsApp Image 2025-06-19 at 2.14.49 PM (1).jpeg"
import cHall2 from "../Images/Conference Hall/WhatsApp Image 2025-06-19 at 2.14.49 PM (2).jpeg"
import cHall3 from "../Images/Conference Hall/WhatsApp Image 2025-06-19 at 2.14.50 PM (1).jpeg"
import cHall4 from "../Images/Conference Hall/WhatsApp Image 2025-06-19 at 2.14.50 PM.jpeg"

import gbar1 from "../Images/Resized/Garden Bar/GardenLawn (1).avif"
import gbar2 from "../Images/Resized/Garden Bar/GardenLawn (2).avif"
import gbar3 from "../Images/Resized/Garden Bar/GardenLawn (3).avif"
import gbar4 from "../Images/Resized/Garden Bar/GardenLawn (4).avif"
import gbar5 from "../Images/Resized/Garden Bar/GardenLawn (5).avif"
import gbar6 from "../Images/Resized/Garden Bar/GardenLawn (6).avif"

//Restaurant
// import Restaurant from "../Images/Restro/IMG_8060-HDR-2.jpg";
// import Restaurant1 from "../Images/Restro/IMG_8139-HDR-2.jpg";
// import Restaurant2 from "../Images/Restro/IMG_8108-HDR-2.jpg";
// import Restaurant3 from "../Images/Resized/Dinning/IMG_0271.png";
const doctor =[doc,doc1,doc2,doc3,doc4,doc5]
const Restaurant=[Dinning1,  Dinning2, Dinning3,Dinning4,Dinning5,Dinning6,Dinning7,Dinning8,Dinning9,Dinning10,Dinning11,Dinning12];
const Bar = [BarImg1, BarImg2, BarImg3, BarImg4, BarImg5, BarImg6, BarImg7, BarImg8, BarImg9, BarImg10, BarImg11, BarImg12, BarImg13];
const Games = [GamesImg1, GamesImg2, GamesImg3, GamesImg4, GamesImg5, GamesImg6, SwimmingImg1,SwimmingImg2,SwimmingImg3,SwimmingImg5];
const Lawn = [Lawn1, Lawn2, Lawn3, Lawn4, Lawn5, Lawn6, Lawn7, Lawn8, Lawn9, Lawn10, Lawn11, Lawn12, Lawn13, Lawn14, Lawn15, Lawn16, Lawn17];
const Nights = [MNight, MNight2, MNight3, MNight4, MNight5, MNight1];
const BanquetHall = [Dinning1,  Dinning2, Dinning3,Dinning4];
const Gym = [GymImg1,GymImg2,GymImg3,GymImg4,GymImg5,GymImg6,GymImg7,GymImg8,GymImg9,GymImg10,GymImg11,GymImg12,GymImg13,GymImg14,GymImg15,GymImg16,GymImg17,GymImg18,GymImg19,GymImg20,GymImg21,GymImg22,SwimmingImg3,SwimmingImg4];
const Swimming = [SwimmingImg1,SwimmingImg2,SwimmingImg3,SwimmingImg5];
const Dandiya = [Dandiya1, Dandiya2, Dandiya3, Dandiya4, Dandiya5];
const Jan = [Republic, Republic1, Republic2, Republic3, Republic4];
const Independ = [Independence, Independence2, Independence3, Independence4, Independence5];
const Lohari = [lohri1, lohri2, lohri3, lohri4, lohri5];
const Diwali = [diwali1, diwali2, diwali3, diwali4, diwali5];
const FusionNight = [Night1, Night2, Night3, Night4, Night5];
const NewYear = [New1, New2, New3, New4, New5];
const Room = [Room1, Room2, Room3, Room4, Room5];
const Confresshall = [cHall,cHall1,cHall2,cHall3,cHall4];
const CardImg = [Card1,Card2,box];
const GBar=[gbar1,gbar2,gbar3,gbar4,gbar5,gbar6]


export {Restaurant,GBar,Confresshall,doctor,CardImg, Bar,Games,Lawn,BanquetHall,Nights,Gym, Swimming, Dandiya,Room, Jan, Diwali, FusionNight, NewYear, Lohari, Independ}